import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = {
  role: "group",
  class: "form-group"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, "매듭 카테고리", -1)
const _hoisted_7 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "선택...", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "매듭 이름", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "유튜브 URL", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_20 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.knot.category_info = $event)),
                  required: ""
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createBlock("option", {
                      key: category.id,
                      value: category.id + '|' + category.category_name
                    }, _toDisplayString(category.category_name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.knot.category_info]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.knot.knot_name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.knot.knot_name]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.knot.youtube_url = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.knot.youtube_url]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("label", _hoisted_18, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.knot.is_show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.knot.is_show]
                    ]),
                    _hoisted_19
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                "folder-name": 'knots'
              }, null, 512)
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "Add new",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}